import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_triangle-arrow-top",
  "use": "svg_triangle-arrow-top-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\" id=\"svg_triangle-arrow-top\"><path d=\"m5 0 4.763 6H.237L5 0Z\" fill=\"#959382\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol